// 无登录状态的产品中心
import React, { 
  useCallback, useContext, useEffect, useState 
} from 'react';
import {
  Box, Breadcrumbs, Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, Link, ListItemIcon, Menu, MenuItem, Paper, Toolbar, Typography,
} from '@mui/material';

import { Favorite, Share } from '@mui/icons-material';
import { Link as RouteLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { getCatlogsAction, getFilterAction, getLanguageAction } from '@ivymobi/orbit-core/business/productCenter';
import { getOutCatlogsAction, useOutProducts } from '@ivymobi/orbit-core/business/user';
import { createShareAction } from '@ivymobi/orbit-core/business/share';
import { documentEventAction } from '@ivymobi/orbit-core/business/document';

import { LanuageContext, TenantContext, UserContext, DeviceType } from '../orbit-context';
import Carousel from '../components/Carousel/index.js'
import { Loading } from '../components';

import FilterView from '../products/components/filterView';
import ProductsView from '../products/components/productsView';

import SearchInput from './components/searchInput';
import ProdcutView from './productView';
import FavorDialog from '../documents/favor';
import ShareForm from '../documents/share';
import RobotSearch from '../newproductTemp/components/robotSearch';
import { getProductImage } from '@ivymobi/orbit-core';

const queryParse = (query) => {
  query = query.substring(query.indexOf('?') + 1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0, item.indexOf('='));
    let value = decodeURIComponent(item.substring(item.indexOf('=') + 1));
    params[key] = value;
  });
  return params;
}
export default function ProductContainer() {
  const [t] = useTranslation();
  let params = queryParse(location.search);

  const history = useHistory();
  const dispatch = useDispatch();
  const user = useContext(UserContext);
  const tenant = useContext(TenantContext);
  const deviceType = useContext(DeviceType);
  const { id } = useParams<any>() ?? {id: null};
  // console.log('current id ==== ', id)

  const [customFilter, setCustomFilter] = useState('');
  console.log("searchText-=====",params?.search)
  const [searchText, setSearchText] = useState(params?.search);
  const [selectInfo, setSelectInfo] = useState({show: false, item: null, target: null});
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [[mode, selectedIds], setModeAndData] = useState(['normal', []]);
  const [favSuccess, setFavSuccess] = useState(false);
  const [moduls, setModuls] = useState([]);
  const [[anchorEl, selectId], setAnchorEl] = useState([null, null]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModeAndData(['normal', []]);
  };
  const handleMenuClose = () => {
    setAnchorEl([null, null]);
  };
  const handleShare = () => {
    handleMenuClose()
    if (id === null || id.length === 0) {
      setModeAndData(['share', [selectId]]);
    } else {
      setModeAndData(['share', [id]]);
    }
  };
  const handleFav = () => {
    handleMenuClose()
    if(id === null || id.length === 0) {
      setModeAndData(['favor', [selectId]]);
    } else {
      setModeAndData(['favor', [id]]);
    }
  };
  const createShare = (settings) => {
    if (!settings?.acl) {
      settings.acl = {};
    }
    // 分享 shareType
    settings.shareType = 'web';
    dispatch(createShareAction({user, tenant, share: {
      ...settings,
      tenantId: tenant.id,
      documents:selectedIds
    }})).then((share) => {
      // @todo 暂时只支持一个文件的统计， 因为 ui 现在还不支持多选
      dispatch(documentEventAction({ user, tenant, document: { id: selectedIds[0] }, type: 'share', shareType: 'showcase' }));
      window.open(`/shares/${share.id}`);
      setModeAndData(['normal', []]);
    });
  };
  const handleSlShare = (id) => {
    handleMenuClose();
    if (id !== null || id.length !== 0) {
      setModeAndData(['share', [id]]);
    }
  };
  const handleSlFav = (id) => {
    handleMenuClose();
    if (id !== null || id.length !== 0) {
      setModeAndData(['favor', [id]]);
    }
  };

  useEffect(() => {
    window.addEventListener('message', function(e) {
      if (e.data.type === 'collection' && e.data.item) {
        setAnchorEl([null, e.data.item.type === 'catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid]);
        handleSlFav(e.data.item.type === 'catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid);
      } else if(e.data.type === 'share' && e.data.item) {
        setAnchorEl([null, e.data.item.type === 'catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid]);
        handleSlShare(e.data.item.type==='catalog' ? e.data.item.cgId : e.data.item.details.supplierAltPid);
      }
    });
     console.log("======================")
    // 产品中心首页的产品目录
    if (!id) {
      console.log("=========== id === null ===========")
      setLoading(true);
      dispatch(getOutCatlogsAction({tenantId: tenant.id, id, nameFilter: searchText, shorturl: (customFilter && customFilter.length > 0) ? encodeURI(customFilter) : null})).then((allProductsInfos) => {
        // console.log('all catalogs = ', allProductsInfos)
        const _allcats = _.filter(allProductsInfos.catalogs, (item) => {
          if (item.csIndex === '0') return false;
          return true;
        });
        let _moduls = [];
        _allcats.map(item => {
          item.type = 'catalog';
          let image = getProductImage(item?.mime) 
          let title = item.cgName.zh
          _moduls.push({link: '/products/' + item.id, image: image, title: title})
        });
        console.log('moduls === ', _moduls)
        setModuls(_moduls);
        setLoading(false);
      }, (e) => {
        setLoading(false);
      });
    }
  },[id,searchText])
  useEffect(()=>{
    setSearchText(params?.search??'')
  },[params?.search])
  useEffect(() => {
    if (selectInfo.target === null) return;
    setAnchorEl([
      selectInfo.target, 
      selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : selectInfo.item.details.supplierAltPid]);
  }, [selectInfo]);

  if (loading) {
    return (<Loading />)
  }
  
  if(!id&&!params?.search) {
    return (
      <Box style={{ width:'100%', height:'calc(76vh)', position:'relative', display:'flex', justifyContent:"center", alignItems:'center' }}>
        {deviceType === 'desktop' && <Box style={{ position:'relative', width:"90%", height:"100%", overflow:'hidden' }}>
          <Box style={{position:'absolute',top:'0px',width:'100%',height:'30px',zIndex:100,display:'flex',justifyContent:'center'}}>
            <Box style={{display:'flex',alignItems:'center',width:'94%',maxWidth:'380px'}}>
              <RobotSearch doSearch={(value) => {console.log("****************");  history.push(`/products?search=${value}`) }} />

            </Box>
          </Box>
          <Carousel items={moduls} history={history} addEvent={()=>{}}/>
        </Box>}
        {deviceType === 'mobile' && <Box style={{ position:'relative', width:"100%", height:"100%", overflow:'hidden' }}>
          <Box style={{position:'absolute',top:'0px',width:'100%',height:'30px',zIndex:100,display:'flex',justifyContent:'center'}}>
            <Box style={{display:'flex',alignItems:'center',width:'94%',maxWidth:'380px'}}>
              <RobotSearch doSearch={(value) => {console.log("****************");  history.push(`/products?search=${value}`) }} />
            </Box>
          </Box>
          <Carousel items={moduls} history={history} addEvent={()=>{}}/>
        </Box>}
      </Box>
    ) 
  }

  return (
    <Paper style={{ height:'100%', flex: 1, display:'flex', justifyContent:'center', alignItems:'center', backgroundImage:'url(/images/background.png)', backgroundSize:'cover' }} elevation={0}>
      {deviceType === 'desktop' && <Box style={{ width:'80%', height:'100%', overflow: 'hidden' }}>
        <ProdcutView handleShare={handleShare} handleFav={handleFav} searchText={searchText}/>
      </Box>}
      {deviceType === 'mobile' && <Box style={{ width:'100%', height:'100%', overflow: 'hidden' }}>
        <ProdcutView handleShare={handleShare} handleFav={handleFav} searchText={searchText}/>
      </Box>}

      <Dialog open={mode === 'favor'} maxWidth="sm" fullWidth onClose={handleClose}>
        <FavorDialog selectedIds={selectedIds} onClose={handleClose} setFavSuccess={setFavSuccess}/>
      </Dialog>

      <Dialog maxWidth="sm" fullWidth open={favSuccess} onClose={() => { setFavSuccess(false); }} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040209')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            { t('common.collectionNotify')}！
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='primary' size="medium" onClick={() => { setFavSuccess(false); }} autoFocus>
            { t('common.confirm')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={mode === 'share'} maxWidth="sm" fullWidth onClose={handleClose}>
        <ShareForm downloadable={false} onSubmit={createShare}  documents={{[selectedIds[0]]:selectInfo}} selectedId={selectedIds}/>
      </Dialog>
    </Paper>
  )
}